import api from './api'

export const backupsAPI = {
  createFull: () => api.post('/backups/full'),
  createDifferential: (lastFullBackupDate) => api.post('/backups/differential', { lastFullBackupDate }),
  getAll: (type = 'all') => api.get('/backups', { params: { type } }),
  getStats: () => api.get('/backups/stats'),
  getDownloadUrl: (path) => api.get('/backups/download', { params: { path } }),
}

